import React, { useState } from "react";
import { HiMenu } from "react-icons/hi";
import { Popover } from "react-tiny-popover";
import History from "../../../utils/services/GlobalNavigation/navigationHistory";
import "./LandingHeader.scss";
import { GoArrowUpRight } from "react-icons/go";




const LandingHeader: React.FC = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  return (
    <div className="LandingHeader">
      <div className="LandingHeader__logoContainer">
        <img
          src="/LighthouseLogo.svg"
          alt="lighthouseLogo"
          height={"100%"}
          width={"auto"}
          className="ptr"
          onClick={() => {
            History.push("/");
          }}
        />
      </div>
      <div className="LandingHeader__routeContainer">
        <p
          className="LandingHeader__routeContainer_link "
         
        >
          Features
        </p>
        <p
          className="LandingHeader__routeContainer_link "
        
        >
          Pricing
        </p>
        <p
          className="LandingHeader__routeContainer_link "
         
        >
          Ecosystem
        </p>
        <p
          className="LandingHeader__routeContainer_link"
         
        >
          FAQ
        </p>
        <p
          className="LandingHeader__routeContainer_link "
          onClick={() => {
            window.open(
              `https://docs.lighthouse.storage/lighthouse-1/`,
              "_blank"
            );
          }}
        >
          Documentation <span style={{fontSize: '0.8rem'}}>
          <GoArrowUpRight />
          </span>
        </p>
      </div>

      <div className="LandingHeader__getStartedButton">
        <button
          className="fillBtn__blue"
          onClick={() => {
            // setLoginDialog(true);
          }}
        >
          Get Started
        </button>
      </div>

      <div className="LandingHeader__menuContainer">
        <Popover
          isOpen={isPopoverOpen}
          positions={["bottom", "left", "right"]}
          onClickOutside={() => setIsPopoverOpen(false)}
          containerClassName={"mobileMenu"}
          content={
            <div className="menu">
              <p
                className="LandingHeader__routeContainer_link "
               
              >
                Features
              </p>

              <p
                className="LandingHeader__routeContainer_link"
              
              >
                Contact Us
              </p>
              <p
                className="LandingHeader__routeContainer_link"
              
              >
                FAQ
              </p>
              <p
                className="LandingHeader__routeContainer_link "
             
              >
                Pricing
              </p>
            </div>
          }
        >
          <div
            onClick={() => setIsPopoverOpen(true)}
            style={{ color: "white" }}
          >
            <HiMenu />
          </div>
        </Popover>
      </div>
    </div>
  );
}

export default LandingHeader;